import { createSelector } from 'reselect'

export const getRegionsByCountry = createSelector(
  (state, country) => state.geoObjects && state.geoObjects.regions && state.geoObjects.regions.byCountry &&
    state.geoObjects.regions.byCountry[country] ? state.geoObjects.regions.byCountry[country] : [],
  (regions) => regions
)
